import React from "react";
import { motion } from "framer-motion"; // Keep this for animation (if needed)

export default function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      {/* Replace the turtle with the spinner */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          repeat: Infinity,
          repeatType: "loop",
          duration: 2,
        }}
      >
        <div className="spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </motion.div>
    </div>
  );
}
